import React, { useState, useEffect, useCallback } from 'react'
import { Button, Col, Form, Image, Input, Row, Select, Typography } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import { useAuthContext } from 'contexts/Auth'
import { useDropzone } from 'react-dropzone'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import statuses from 'data/statuses.json'

const { Title, Text } = Typography

const initialState = {
  fullName: '',
  email: '',
  designation: '',
  usdcAddress: '',
  imageURL: '',
  status: null
}

export default function AddEmployee() {
  const { getApiConfig } = useAuthContext()
  const [isNew, setIsNew] = useState(true)
  const [state, setState] = useState(initialState)
  const [isImageVisible, setIsImageVisible] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [image, setImage] = useState(null)


  const params = useParams()

  const { getRootProps, getInputProps } = useDropzone({
    accept: { 'image/*': [] }, multiple: false,
    onDrop: acceptedFiles => { setImage(acceptedFiles[0]) }
  });

  const readEmployee = useCallback(() => {
    if (params.id !== "add") {
      axios.get(`${window.api}/employee/single/${params.id}`, getApiConfig())
        .then(res => {
          if (res.status === 200) {
            const { employee } = res.data
            setState(s => ({ ...s, ...employee }))
            setIsNew(false)
          }
        })
        .catch(err => {
          window.toastify(err.response?.data?.message || "Error fetching employee", "error")
        })
    } else {
      setState(initialState)
      setIsNew(true)
    }
  }, [params.id, getApiConfig])

  useEffect(() => { readEmployee() }, [readEmployee])

  const handleChange = e => {
    const { name, value } = e.target
    setState(s => ({ ...s, [name]: value }))
  }

  const handleChangeSelect = (name, value) => {
    setState(s => ({ ...s, [name]: value }))
  }

  const handleSubmit = () => {
    const {
      fullName, email,
      designation, usdcAddress,
      status,
      imageURL
    } = state

    if (!fullName) return window.toastify("Full Name is required", "error")
    if (!email) return window.toastify("Email is required", "error")
    if (!designation) return window.toastify("Designation is required", "error")
    if (!usdcAddress) return window.toastify("USDC Wallet Address is required", "error")
    if (!status) return window.toastify("Status is required", "error")
    if (!image && !imageURL) { return window.toastify("Please upload USDC deposit QR code ", "error") }

    const formData = new FormData()
    Object.entries(state).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
    if (image) { formData.append('image', image) }

    // for (let pair of formData.entries()) {
    //   console.log(`${pair[0]}:`, pair[1]);
    // }
    setIsProcessing(true)
    axios[isNew ? 'post' : 'patch'](`${window.api}/employee/${isNew ? 'create' : `update/${state.id}`}`, formData, getApiConfig())
      .then(res => {
        if (res.status === (isNew ? 201 : 200)) {
          window.toastify(res.data.message, "success")
          setState(initialState)
        }
      })
      .catch(err => {
        console.error(err)
        window.toastify(err.response?.data?.message || "Error submitting data", "error")
      })
      .finally(() => setIsProcessing(false))
  }

  return (
    <>
      <Row className='mb-4'>
        <Col span={24}>
          <div className="flex-between">
            <Title level={3} className="mb-0">{isNew ? "Add New" : "Update"} Employee</Title>
            <Button type='primary' loading={isProcessing} onClick={handleSubmit}>{isNew ? "Add" : "Update"}</Button>
          </div>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} lg={18}>
          <div className="card">
            <Form layout="vertical">
              <Row gutter={16}>
                <Col xs={24} lg={12}>
                  <Form.Item label="Full Name" required>
                    <Input name="fullName" value={state.fullName} onChange={handleChange} placeholder="Enter full name" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="Email" required>
                    <Input name="email" value={state.email} onChange={handleChange} placeholder="Enter email" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="Designation" required>
                    <Input name="designation" value={state.designation} onChange={handleChange} placeholder="Enter designation" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="USDC Wallet Address" required>
                    <Input name="usdcAddress" value={state.usdcAddress} onChange={handleChange} placeholder="Enter Binance USDC wallet address" />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item label="Status" required>
                    <Select showSearch placeholder="Select status" value={state.status} onChange={value => handleChangeSelect("status", value)} options={statuses} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>

        <Col xs={24} lg={6} className='mt-3 mt-lg-0'>
          <div className="card p-2">
            <Text className='mb-1'><Text style={{ color: "#ff4d4f" }}>*</Text> <b>Upload USDC Deposit Address QR Code</b> </Text>
            <div {...getRootProps({ className: 'dropzone text-center' })}>
              <InboxOutlined />
              <input {...getInputProps()} />
              <p>Click or drag image</p>
            </div>
            {(image || state.imageURL) && <Text className='text-primary cursor-pointer text-decoration-underline' onClick={() => { setIsImageVisible(true) }}>Click to view image</Text>}
          </div>
        </Col>
      </Row>
      {(image || state.imageURL) && <Image preview={{ visible: isImageVisible, src: image ? URL.createObjectURL(image) : state.imageURL, onVisibleChange: (value) => { setIsImageVisible(value) } }} />}

    </>
  )
}
